import { render } from "./Unit3-3.vue?vue&type=template&id=9728e2ca&scoped=true"
import script from "./Unit3-3.vue?vue&type=script&lang=js"
export * from "./Unit3-3.vue?vue&type=script&lang=js"

import "../assets/css/common.css?vue&type=style&index=0&lang=css"
import "../assets/css/Unit3-3.css?vue&type=style&index=1&id=9728e2ca&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\project\\national-museum-website\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9728e2ca"]])

export default __exports__